import { render, staticRenderFns } from "./AutoAllocateAction.vue?vue&type=template&id=18cefd4b"
import script from "./AutoAllocateAction.vue?vue&type=script&lang=js"
export * from "./AutoAllocateAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports